import axios from 'axios';
import Vue from 'vue';

export const actions = {
  async loadUserData({ commit }) {
    try {
      const { data } = await axios.get('/api/v1/user/?expands=award');
      commit('userInformationLoaded', { userInformation: data });
    } catch (error) {
      return;
    }
  },
};
